// @flow
// Decoders
import { createDecoder } from 'fc-decoders'
import decoder from './decoders/spatial'

// Exports
export default createDecoder(decoder)
